export const socialLinks = {
  github: "https://github.com/xtoshi999/",
  // discord: "https://discord.com/users/546828755419660297",
  gmail: "mailto:xtoshi999.degen@gmail.com",
  twitter: "https://x.com/xtoshi999",
  telegram: "https://t.me/xtoshi999",
};
